/**
 * Checks if a given value is a valid Date object.
 *
 * @param {any} date - The value to check.
 * @returns {boolean} - Returns true if the value is a valid Date object, false otherwise.
 */
export const isValidDate = (date) => {
  return date instanceof Date && !isNaN(date.getTime());
};
